import { assert_not_equal, assert_number_gte_0 } from '@shared/asserts/utils_asserts';
import { DTO__image_size } from '@shared/dto/+image/image_asset_base/DTO__image_size';
import { CONSTANTS_GENERATION__value_range } from './CONSTANTS_GENERATION__value_range';

export enum ENUM__image_size_name {
  CUSTOM = 'CUSTOM',
  SIZE_720 = '720p',
  //
  SIZE_1K = '1K',
  SIZE_2K = '2K',
  SIZE_4K = '4K',
  SIZE_8K = '8K',
  //
  SIZE_MAX = 'MAX',
}

export namespace ENUM_UTILS__image_size_name {
  export function get_image_side_square(image_size_name: ENUM__image_size_name) {
    assert_not_equal(image_size_name, ENUM__image_size_name.CUSTOM);

    let out_map = new Map<ENUM__image_size_name, number>([
      [ENUM__image_size_name.SIZE_720, 720],
      [ENUM__image_size_name.SIZE_1K, 1024],
      [ENUM__image_size_name.SIZE_2K, 2048],
      [ENUM__image_size_name.SIZE_4K, 4096],
      [ENUM__image_size_name.SIZE_8K, 8192],
      [ENUM__image_size_name.SIZE_MAX, CONSTANTS_GENERATION__value_range.IMAGE_SIZE_OUT.max],
    ]);

    let out = out_map.get_or_assert(image_size_name);

    return out;
  }

  export function get_image_size_name(longest_side: number, aspect_ratio: number): ENUM__image_size_name {
    assert_number_gte_0(aspect_ratio);
    assert_number_gte_0(longest_side);

    // Calculate base_side (the shorter dimension if square-equivalent) based on orientation
    let base_side = aspect_ratio >= 1 ? Math.round(longest_side / aspect_ratio) : Math.round(longest_side * aspect_ratio);

    base_side = base_side.snap_to_8();

    const valid_values = Object.values(ENUM__image_size_name).filter(item => item !== ENUM__image_size_name.CUSTOM);

    const match = valid_values.find(preset => {
      const expected_longest_side = DTO__image_size.get_longest_side_for(preset, aspect_ratio);
      return expected_longest_side === longest_side;
    });

    return match ?? ENUM__image_size_name.CUSTOM;
  }
}
